// test2149
(2149 && 0);
